module.exports = __webpack_public_path__ + "img/brand_icon02.0a0c7eb.b3920d28.png";